"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ucfirst;
exports.ucfirstEachWord = ucfirstEachWord;

var _ucfirst = _interopRequireDefault(require("ucfirst"));

var _checkTypes = _interopRequireDefault(require("check-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ucfirst(text) {
  if (!_checkTypes["default"].nonEmptyString(text)) {
    return text;
  }

  return (0, _ucfirst["default"])(text.toLowerCase());
}

function ucfirstEachWord(text) {
  if (!_checkTypes["default"].nonEmptyString(text)) {
    return text;
  }

  var fragments = text.split(' ');
  return fragments.map(function (f) {
    return ucfirst(f);
  }).join(' ');
}